import { createNextTableContext } from '@core/table';

export const CurrentMonthDeclarationTableContext = createNextTableContext();
